import { Check } from 'lucide-react';

export type FloorplanStep = 'upload' | 'unit-selection' | 'labels' | 'editor' | 'review' | '3d' | 'branding';

const steps: { id: FloorplanStep; label: string }[] = [
  { id: 'upload', label: 'Upload' },
  { id: 'unit-selection', label: 'Grundriss' },
  { id: 'labels', label: 'Räume' },
  { id: 'editor', label: 'Einbauten' },
  { id: 'review', label: 'Ergebnis' },
  { id: '3d', label: '3D' },
  { id: 'branding', label: 'Branding' },
];

interface FloorplanStepIndicatorProps {
  currentStep: FloorplanStep;
}

export const FloorplanStepIndicator: React.FC<FloorplanStepIndicatorProps> = ({ currentStep }) => {
  const currentIndex = steps.findIndex((s) => s.id === currentStep);

  return (
    <div className="w-full">
      <div className="flex items-center justify-center">
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isCurrent = step.id === currentStep;

          return (
            <div key={step.id} className="flex items-center">
              {index > 0 && (
                <div
                  className={`w-6 md:w-10 h-1 mx-1 md:mx-2 rounded transition-colors duration-300 ${
                    isCompleted || isCurrent ? 'bg-primary' : 'bg-muted'
                  }`}
                />
              )}
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold transition-colors duration-300
                    ${
                      isCompleted
                        ? 'bg-primary text-primary-foreground'
                        : isCurrent
                          ? 'bg-primary text-primary-foreground'
                          : 'bg-muted text-muted-foreground'
                    }
                  `}
                >
                  {isCompleted ? <Check className="w-4 h-4" /> : index + 1}
                </div>
                <span
                  className={`text-xs mt-1 font-medium whitespace-nowrap hidden md:block ${
                    isCurrent ? 'text-primary' : 'text-muted-foreground'
                  }`}
                >
                  {step.label}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
